import { render, staticRenderFns } from "./SectionChecks.vue?vue&type=template&id=530b5ea5&scoped=true&"
import script from "./SectionChecks.vue?vue&type=script&lang=js&"
export * from "./SectionChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b5ea5",
  null
  
)

export default component.exports